import React from 'react';
import Modal from 'react-bootstrap/Modal';

const PointInfoModal = ({ show, onHide, t }) => {
    if (!show) return null;

    return (
        <Modal
            size="lg"
            centered
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            enforceFocus={false}
            className="profile-point-info-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title className="d-flex align-items-center">
                    <i className="icon fal fa-info-circle ml-2 text-indigo"></i>
                    <span>{t('Pages.Profile.point') || 'معلومات النقاط'}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="widget widget-category mb-0">
                    <div className="widget-body">
                        <p className="text-justify leading-relaxed text-slate">
                            {t('Pages.Profile.pointInfo')}
                        </p>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default PointInfoModal;
